import type { IdentitySuccess } from "@/lib/identity-contract";

/** The wire shape of `GET /identity/users`. */
export type UserListResponse = IdentitySuccess<"listUsers">;

export type User = UserListResponse["data"][number];

export type UserStatus = User["access_status"];

export const USER_STATUSES = [
  "waitlist",
  "active",
  "suspended",
] as const satisfies readonly UserStatus[];

export const USER_STATUS_FILTERS = ["all", ...USER_STATUSES] as const;
export type UserStatusFilter = (typeof USER_STATUS_FILTERS)[number];

/** The wire shape of `PATCH /identity/users/{id}/status`. */
export type UpdateUserStatusResponse = IdentitySuccess<"setUserStatus">;

/** What a status change answers: the account, without the list row's `created_at`. */
export type UpdatedUserStatus = UpdateUserStatusResponse["data"];

export interface UserListResult {
  users: readonly User[];
  total: number;
}
